import { NOT_FOUND } from 'shared/consts/codes'

import BackendError from './BackendError'

class NotFoundError extends BackendError {
  constructor(message) {
    super(message)
    // Ensure the name of this error is the same as the class name
    this.name = this.constructor.name
    this.status = NOT_FOUND

    // This clips the constructor invocation from the stack trace.
    // It's not absolutely essential, but it does make the stack trace a little nicer.
    //  @see Node.js reference (bottom)
    Error.captureStackTrace(this, this.constructor)
  }
}

export default NotFoundError
